import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';

import { APP_CONFIG } from '@kav/services/config.service';

@NgModule()
export class KavModule
{
    constructor(@Optional() @SkipSelf() parentModule: KavModule)
    {
        if ( parentModule )
        {
            throw new Error('KavModule is already loaded. Import it in the AppModule only!');
        }
    }

    static forRoot(config): ModuleWithProviders<KavModule>
    {
        return {
            ngModule : KavModule,
            providers: [
                {
                    provide : APP_CONFIG,
                    useValue: config
                }
            ]
        };
    }
}
